//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// user-image imports
import { IProps } from "./user-image.d";
import * as styles from "./user-image.styles";
import { InfoTip } from "@components/tool-tip";

//////////////////
// COMPONENT
//////////////////
export class UserImage extends React.PureComponent<IProps, {}> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const { imgUrl, name, showInfoTipName, infoTipText, style } = this.props;
    const userImage = (
      <div style={{ ...styles.container, ...style }}>
        {!!imgUrl ? (
          <img style={styles.userImg} src={imgUrl} />
        ) : (
          <div style={{ ...styles.userImg, ...styles.noUserImg }}>{(name && name[0]) || "C"}</div>
        )}
      </div>
    );

    let render = userImage;
    if (showInfoTipName || infoTipText) {
      const text = infoTipText ? infoTipText : name;
      render = <InfoTip targetElement={userImage} text={text} tipType={"info"} />;
    }

    return render;
  }
}
